import useGetSupplierQuery from '@/api/queries/useGetSupplierQuery';
import Button from '@/components/Button';
import SpinnerIcon from '@/components/icons/SpinnerIcon';
import PageHeader from '@/components/PageHeader';
import SearchForm from '@/components/search/SearchForm';
import useSearch from '@/components/search/useSearch';
import Breadcrumbs from '@/modules/admin/components/Breadcrumbs';
import SupplierToRetailerTable from '@/modules/admin/components/SupplierToRetailerTable';
import { SupplierToRetailerAddPath } from '@/modules/admin/paths';
import { LinkIcon } from '@heroicons/react/24/solid';
import { useParams } from 'react-router-dom';

const SupplierToRetailerList = () => {
  const { supplierId } = useParams();

  const { searchQuery, page, handleSearchSubmit, handlePageChange, setSearchQuery } = useSearch();

  const { isLoading, supplier } = useGetSupplierQuery(supplierId);

  if (isLoading) {
    return (
      <div className="flex justify-center py-20">
        <SpinnerIcon />
      </div>
    );
  }

  if (!supplier) {
    return;
  }

  return (
    <>
      <Breadcrumbs />

      <PageHeader title="Supplier &#128073; Retailer">
        <Button
          to={SupplierToRetailerAddPath.withSupplierId(supplier.id)}
          icon={<LinkIcon className="h-5 w-5 mr-1" />}
          variant="secondary"
        >
          Link Retailer
        </Button>
      </PageHeader>

      <SearchForm
        onSubmit={handleSearchSubmit}
        onChange={setSearchQuery}
        value={searchQuery}
        placeholder="Search by name"
      />

      <SupplierToRetailerTable
        supplier={supplier}
        searchQuery={searchQuery}
        page={page}
        onChangePage={handlePageChange}
      />
    </>
  );
};

export default SupplierToRetailerList;
